import { getMeta } from '../meta.js';
import { showConfirmBox, showMessageBox } from '../msgbox.jsx';
import xhr from '../xhr.js';

function selectFile() {
    return new Promise(resolve => {
        let input;

        const complete = value => {
            if(!resolve) return;
            resolve(value);
            resolve = null;
            document.body.removeChild(input);
        };

        document.body.appendChild(input = <input type="file" class="hidden" name="image" accept="image/*" oncancel={() => void complete(null)} onchange={() => void complete(input.files[0])} />);
        input.click();
    });
}

function readFile(file, type) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader;
        reader.onload = () => void resolve(reader.result);
        reader.onerror = err => void reject(err);
        if(type === 'arraybuffer') reader.readAsArrayBuffer();
        else if(type === 'dataurl') reader.readAsDataURL();
        else if(type === 'text') reader.readAsText();
        else reject(new Error('reject param must be "arraybuffer", "dataurl" or "text'));
    });
}

(() => {
    const avatarUri = getMeta('profile-avatar');
    if(typeof avatarUri !== 'string')
        return;

    const avatarWrapper = document.querySelector('.js-profile-avatar');
    if(!avatarWrapper)
        return;

    const profileRoot = document.querySelector('.js-profile');
    if(!profileRoot)
        return;

    const avatarImage = avatarWrapper.querySelector('img');

    let hasFocus, hasPointer;

    const activate = () => void avatarWrapper.classList.add('profile-header-avatar-active');
    const deactivate = () => {
        if(!hasFocus && !hasPointer)
            avatarWrapper.classList.remove('profile-header-avatar-active');
    };

    const refresh = () => {
        const url = new URL(avatarImage.src);
        url.searchParams.set('', Date.now());
        avatarImage.src = url.href;
    };

    let avatarEditor;

    const clickChange = async () => {
        if(!avatarWrapper.classList.contains('profile-header-avatar-active') || avatarEditor)
            return;

        profileRoot.classList.add('profile-translucent');

        const file = await selectFile();
        if(file === null) {
            profileRoot.classList.remove('profile-translucent');
            return;
        }

        const removeForm = () => {
            avatarEditor.remove();
            avatarEditor = null;
            profileRoot.classList.remove('profile-translucent');
        };

        const fileUrl = URL.createObjectURL(file);
        //let crop, area;

        profileRoot.parentNode.insertBefore(avatarEditor = <form class="container profile-avatar-editor" onsubmit={async function(ev) {
            ev.preventDefault();

            if(this.dataset.disabled)
                return;
            this.dataset.disabled = '1';
            avatarEditor.classList.add('profile-avatar-editor-busy');

            try {
                for(let i = 0; i < this.elements.length; ++i) {
                    const element = this.elements[i];
                    element.dataset.disabled = element.disabled ? '1' : '';
                    element.disabled = true;
                }

                const params = new FormData;
                params.set('image', file); // use cropped version

                const { status, body } = await xhr.put(avatarUri, { authed: true, csrf: true, type: 'json' }, params);

                switch(status) {
                case 204: break;
                case 404: throw new Error('Profile not found.');
                case 403: throw new Error('You are not allowed to change this avatar.');
                case 400: throw new Error(body?.error?.text ?? 'Something went wrong while processing your avatar change.');
                default: throw new Error(`Received unexpected HTTP status code ${status}.`);
                }

                refresh();
                removeForm();
            } catch(ex) {
                await showMessageBox(ex, 'Avatar');
            } finally {
                for(let i = 0; i < this.elements.length; ++i) {
                    const element = this.elements[i];
                    element.disabled = element.dataset.disabled !== '';
                    delete element.dataset.disabled;
                }

                this.classList.remove('profile-avatar-editor-busy');
                delete this.dataset.disabled;
            }
        }}>
            <div class="profile-avatar-editor-preview"><img src={fileUrl} alt="Preview" class="avatar" /></div>
            <div class="profile-avatar-editor-buttons">
                <button type="submit" class="input__button">Upload</button>
                <button type="button" class="input__button input__button--destroy" onclick={() => void removeForm()}>Cancel</button>
            </div>
            {/*<div class="profile-avatar-editor-body">
                {crop = <div class="profile-avatar-editor-crop" onpointerdown={function(ev) {
                    if(ev.buttons !== 1) {
                        if(crop.hasPointerCapture(ev.pointerId))
                            crop.releasePointerCapture(ev.pointerId);
                        return;
                    }

                    ev.preventDefault();
                    crop.setPointerCapture(ev.pointerId);

                    console.log('press', ev);
                }} onpointermove={function(ev) {
                    if(!crop.hasPointerCapture(ev.pointerId))
                        return;

                    ev.preventDefault();

                    console.log('move', ev);
                }} onpointerup={function(ev) {
                    if(!crop.hasPointerCapture(ev.pointerId))
                        return;

                    ev.preventDefault();
                    crop.releasePointerCapture(ev.pointerId);

                    console.log('release', ev);
                }} >
                    {area = <div style="position: absolute; background: #f00a; top: 0; left: 0; bottom: 0; right: 0; z-index: 100;" />}
                    <img src={fileUrl} alt="Original image" />
                </div>}
            </div>*/}
        </form>, profileRoot);
    };

    const clickDelete = async () => {
        if(!avatarWrapper.classList.contains('profile-header-avatar-active'))
            return;

        if(await showConfirmBox('Are you sure you want to remove this avatar?', 'Removing avatar', null, true)) {
            await xhr.delete(avatarUri, { authed: true, csrf: true });
            refresh();
        }
    };

    avatarWrapper.insertBefore(<>
        <div class="profile-header-avatar-change" tabindex="0" onclick={clickChange}>
            <div class="profile-header-avatar-icon"><i class="fa-solid fa-upload" /></div>
            <div class="profile-header-avatar-label">Upload</div>
        </div>
        <div class="profile-header-avatar-delete" tabindex="0" onclick={clickDelete}>
            <div class="profile-header-avatar-icon"><i class="fa-solid fa-trash-can" /></div>
            <div class="profile-header-avatar-label">Remove</div>
        </div>
    </>, avatarWrapper.firstChild);

    avatarWrapper.addEventListener('focusin', () => { hasFocus = true; activate(); });
    avatarWrapper.addEventListener('mouseover', () => { hasPointer = true; activate(); });
    avatarWrapper.addEventListener('focusout', () => { hasFocus = false; deactivate(); });
    avatarWrapper.addEventListener('mouseout', () => { hasPointer = false; deactivate(); });
})();
